import { Component, Output, EventEmitter, OnInit } from '@angular/core';

import { File } from '@core/objects/file';

import { FileUploadQueue } from '@core/components/storage/storage-files-upload/file-upload-queue.class';

/**
 * @deprecated we should use new app version since 12/10/2026
 */
@Component({
    selector: 'profile-avatar-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss']
})
export class ProfileAvatarUploadComponent implements OnInit{
    // Use MIME type constants from FileUploadQueue for image types
    public allowedImageTypes = FileUploadQueue.ALLOWED_IMAGE_TYPES;
    public isRejected: boolean = false;

    @Output() cancel = new EventEmitter<any>();
    @Output() uploaded = new EventEmitter<File>();

	// constructor(){}

	ngOnInit(){
    }

    upload(files: Array<File>) {
        if(files.length > 0)
            this.uploaded.emit(files[0] );
    }

    uploading(event: any) {
        // console.log("uploading --->", event);
    }

    onCancel() {
        this.cancel.emit(true);
    }

    onFileRejected(event: { filename: string; reason: string }) {
        this.isRejected = true;
    }

    dismissRejection() {
        this.isRejected = false;
    }
}
